import React from 'react';
import classNames from 'classnames';

import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';

import { DeviceType } from 'services/pangolin/types';

import {
  themedDeviceTypeIconClassStyles,
  getDeviceTypeIcon,
} from 'assets/enums/device_types/device_types';

import baseStyles from './device_icon.module.css';

type DeviceIconStyles = {
  iconLayoutContainer: string;
  deviceIconContainer: string;
  deviceIcon: string;
};

const themedStyles: ThemedStyles<DeviceIconStyles> = {
  [Theme.DAYLIGHT]: {
    iconLayoutContainer: baseStyles.iconLayoutContainer,
    deviceIconContainer: baseStyles.deviceIconContainer,
    deviceIcon: baseStyles.deviceIcon,
  },
  [Theme.MIDNIGHT]: {
    iconLayoutContainer: baseStyles.iconLayoutContainer,
    deviceIconContainer: baseStyles.deviceIconContainer,
    deviceIcon: baseStyles.deviceIcon,
  },
};

type DeviceIconProps = {
  type: DeviceType;
};

export const DeviceIcon = ({ type }: DeviceIconProps) => {
  const styles = useStyles(themedStyles);
  const deviceIcons = useStyles(themedDeviceTypeIconClassStyles);
  const deviceIconClass = getDeviceTypeIcon(deviceIcons, type);
  return (
    <div className={styles.iconLayoutContainer}>
      <div className={styles.deviceIconContainer}>
        <div className={classNames(styles.deviceIcon, deviceIconClass)}/>
      </div>
    </div>
  );
};
